/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on the about us page
    let currentIndex = 1;
    const minPage = 1;
    const maxPage = 3;
    const maxItemsPerPages = 10;
    const paginationWrapper = document.querySelector('.pagination');
    const items = document.querySelectorAll('table tbody > tr');
    const numberOfPages = Math.ceil(items.length / maxItemsPerPages);

    initializePagination();

    function initializePagination() {

      addButton('Précédent', currentIndex - 1);

      if (currentIndex - 1 > minPage) {
        addButton('...', 1);
      }

      let pagination = currentIndex;
      if (currentIndex > 1) {
        pagination = currentIndex - 1;
      }

      let i = 0;
      for (let index = pagination; index <= numberOfPages; index++) {
        if (i < maxPage) {
          let button = addButton(index, index);

          if (index == currentIndex) {
            button.classList.add('active');
          }

          i = i + 1;
        }
      }

      if (currentIndex + 1 < numberOfPages) {
        addButton('...', numberOfPages);
      }

      addButton('Suivant', currentIndex + 1);

      for(let i = (currentIndex * maxItemsPerPages) - maxItemsPerPages; i < currentIndex * maxItemsPerPages; i++) {
        if(items[i]) {
          items[i].classList.add('active');
        }
      }
    }

    function setPaginationTo(index) {
      if((index >= minPage && index <= numberOfPages) && index != currentIndex) {
        currentIndex = parseInt(index);
      }
    }

    function addButton(text, index) {
      let button = document.createElement("li");
      button.setAttribute('class', 'page-item');
      button.setAttribute('data-controls', index);

      let link = document.createElement("a");
      link.setAttribute('class', 'page-link');
      link.textContent = text;

      paginationWrapper.append(button);
      button.append(link);

      button.addEventListener('click', function() {
        resetPagination();
        setPaginationTo(button.getAttribute('data-controls'));
        initializePagination();
      });

      return button;
    }

    function resetPagination() {
      items.forEach(function(item) {
        if(item.classList.contains('active')) {
          item.classList.remove('active');
        }
      });

      paginationWrapper.innerHTML = '';
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateEspaceDelegue.js